import { createNamespacedHelpers } from 'vuex'

const { mapActions: mapHomeActions, mapGetters: mapHomeGetters, mapState: mapHomeState } = createNamespacedHelpers('home')
const { mapGetters: mapToolsGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

const HomeMixin = {
  data() {
    return {
      isFormValid: true,
    }
  },
  computed: {
    ...mapHomeState({
      $confirmCancelHome: (state) => state.confirmCancelHome,
      $deleteIndexHome: (state) => state.deleteIndexHome,
      $deleteLabelHome: (state) => state.deleteLabelHome,
      $denyDeleteHome: (state) => state.denyDeleteHome,
      $formHome: (state) => state.formHome,
      $isModalVisibleHome: (state) => state.isModalVisibleHome,
      $promptDeleteHome: (state) => state.promptDeleteHome,
    }),
    ...mapHomeGetters([
      'homeBar',
      'homes',
    ]),
    ...mapToolsGetters([
      'currentNav',
      'routeMap',
    ]),
    ...mapToolsState({
      associationId: (state) => state.associationId,
      baseReportName: (state) => state.baseReportName,
      reportPath: (state) => state.reportPath,
      routeName: (state) => state.routeName,
      subId: (state) => state.subId,
    }),

    confirmCancelHome: {
      get() {
        return this.$confirmCancelHome
      },
      set(value) {
        this.$store.commit('home/confirmCancelHome', value)
      },
    },
    promptDeleteHome: {
      get() {
        return this.$promptDeleteHome
      },
      set(value) {
        this.$store.commit('home/promptDeleteHome', value)
      },
    },
    deleteIndexHome: {
      get() {
        return this.$deleteIndexHome
      },
      set(value) {
        this.$store.commit('home/deleteIndexHome', value)
      },
    },
    deleteLabelHome: {
      get() {
        return this.$deleteLabelHome
      },
      set(value) {
        this.$store.commit('home/deleteLabelHome', value)
      },
    },
    denyDeleteHome: {
      get() {
        return this.$denyDeleteHome
      },
      set(value) {
        this.$store.commit('home/denyDeleteHome', value)
      },
    },
    formHome: {
      get() {
        return this.$formHome
      },
      set(value) {
        this.$store.commit('home/formHome', value)
      },
    },
    isModalVisibleHome: {
      get() {
        return this.$isModalVisibleHome
      },
      set(newValue) {
        this.$store.commit('home/isModalVisibleHome', newValue)
      },
    },
  },
  watch: {
    homes: {
      deep: true,
      handler() {},
    },
  },
  methods: {
    ...mapHomeActions([
      'createHome',
      'deleteHome',
      'updateHome',
      'submitFormHome',
    ]),

    createHomeAndResetForm() {
      const { formHome } = this
      const { action, entry } = formHome

      if (action === 'create' && Array.isArray(entry)) {
        this.createHome()
      } else {
        this.isFormValid = false
      }
    },
    deleteHomeAndResetForm(indexToDelete) {
      this.deleteHome(indexToDelete)
      this.promptDeleteHome = false
    },

    cancelDeleteHome() {
      this.denyDeleteHome = false
      this.promptDeleteHome = false
    },
    askDeleteHome(home) {
      this.deleteIndexHome = home.index
      this.deleteLabelHome = home.textAlt
      this.promptDeleteHome = true
    },
    confirmDeleteHome(home) {
      if (this.homes.length === 1) {
        this.denyDeleteHome = true
      } else {
        this.askDeleteHome(home)
      }
    },
  },
}

export default HomeMixin
